module.exports = __webpack_public_path__ + "static/media/Tyrunt_gaussian2.a0f6de06.png";